import { NgClass } from '@angular/common';
import { Component, input, OnChanges, SimpleChanges } from '@angular/core';
import { SettingsManager, settingsManager } from 'src/app/game/businesslogic/SettingsManager';
import { ChallengeCard } from 'src/app/game/model/data/Challenges';
import { CardRevealDirective } from 'src/app/ui/helper/CardReveal';
import { GhsLabelDirective } from 'src/app/ui/helper/label';
import { GhsTooltipDirective } from 'src/app/ui/helper/tooltip/tooltip';

@Component({
  imports: [CardRevealDirective, GhsLabelDirective, GhsTooltipDirective, NgClass],
  selector: 'ghs-challenge-card',
  templateUrl: './challenge-card.html',
  styleUrls: ['./challenge-card.scss']
})
export class ChallengeCardComponent implements OnChanges {
  readonly inputChallenge = input<ChallengeCard | undefined>(undefined, { alias: 'challenge' });
  get challenge(): ChallengeCard | undefined {
    return this.inputChallenge();
  }

  readonly keep = input<boolean>(false);
  readonly flipped = input<boolean>(false);
  readonly reveal = input<boolean>(false);
  readonly disableFlip = input<boolean>(false);

  revealed: boolean = false;
  animate: boolean = false;

  settingsManager: SettingsManager = settingsManager;

  onChange(revealed: boolean) {
    this.revealed = revealed;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const flipped = changes['flipped'];
    if (flipped && !this.disableFlip() && flipped.currentValue && flipped.currentValue !== flipped.previousValue) {
      this.animate = true;
    }
  }
}
